// extracted by css-extract-rspack-plugin
export default {"wrapper":"iaJFlzeOhBgTMHxZ","clamped":"Te9Atj0VsSdLfHbb","toggle":"FFS4wkDtC4vym9xG"};